// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__g+ykw","iconMinHeight":"Layout_iconMinHeight__WmhuZ"};